(function () {
  const modal = document.getElementById('tunnelModal');
  if (!modal) return;

  const titleEl = modal.querySelector('[data-tunnel-step-title]');
  const itemsWrap = modal.querySelector('[data-tunnel-items]');
  const btnPrev = modal.querySelector('[data-tunnel-prev]');
  const btnNext = modal.querySelector('[data-tunnel-next]');
  const progressBar =
    modal.querySelector('[data-tunnel-progress]') ||
    modal.querySelector('.tunnel-modal__progress-bar');

  const stepIndicator = modal.querySelector('[data-tunnel-step-indicator]');
  const panel = modal.querySelector('.tunnel-modal__panel');

  const visualMain = modal.querySelector('[data-tunnel-visual-main]');
  const visualThumbs = modal.querySelector('[data-tunnel-visual-thumbs]');
  const btnPrevImg = modal.querySelector('[data-tunnel-img-prev]');
  const btnNextImg = modal.querySelector('[data-tunnel-img-next]');

  const footerEl = modal.querySelector('.tunnel-modal__footer');
  let btnBack = null;

  let totalWrap = null;
  let totalEl = null;

  const baseTitleEl = modal.querySelector('[data-tunnel-base-title]');
  const baseMetaEl = modal.querySelector('[data-tunnel-base-meta]');

  const CATEGORY_LABELS_4 = [
  'Équipement passager',
  'Équipement pour rangement',
  'Équipement sécurité',
  'Autre équipement'
];

const CATEGORY_LABELS_3 = [
  'Équipement passager',
  'Équipement sécurité',
  'Autre équipement'
];

const CATEGORY_LABELS_2 = [
  'Équipement sécurité',
  'Autre équipement'
];

  const TITLE_TO_HANDLE = {
    'mise en service application + abonnement': 'mise-en-service-du-fat-street-x-trail'
  };

  let tunnelData = null;
  let steps = [];
  let items = [];
  let stepIndex = 0;

  let gallery = [];
  let galleryIndex = 0;

  const selectedVariants = new Map();
  let baseQty = 1;

  let lastOpener = null;
  let isAdding = false;

  let baseVariantLabel = '';
  let baseVariantIdSnapshot = null;

  const variantsCache = new Map();
  let hydrateTick = 0;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, (m) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    }[m]));
  }

  function stripHtml(html) {
    const div = document.createElement('div');
    div.innerHTML = String(html);
    return div.textContent || div.innerText || '';
  }

  function pick(obj, keys) {
    if (!obj) return undefined;
    for (const k of keys) {
      if (obj[k] !== undefined && obj[k] !== null) return obj[k];
    }
    return undefined;
  }

  function getField(obj, key) {
    if (!obj) return null;

    const direct = obj[key];
    if (direct !== undefined && direct !== null) {
      if (typeof direct === 'object' && direct && 'value' in direct) return direct.value;
      return direct;
    }

    if (Array.isArray(obj.fields)) {
      const f = obj.fields.find((x) => x && x.key === key);
      if (!f) return null;

      const v = f.value;
      if (v !== undefined && v !== null) {
        if (typeof v === 'object' && v && 'value' in v) return v.value;
        return v;
      }
    }

    return null;
  }

  function getFocusable(el) {
    return [...el.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])')]
      .filter((x) => !x.disabled && x.offsetParent !== null);
  }

  function trapFocus(e) {
    if (e.key !== 'Tab') return;
    const focusables = getFocusable(panel || modal);
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  async function retryAfterDelay(res) {
    const ra = res.headers.get('retry-after');
    const seconds = ra ? Number(ra) : NaN;
    const ms = Number.isFinite(seconds) ? seconds * 1000 : 800;
    await new Promise((r) => setTimeout(r, ms));
  }

  function readTunnelData() {
    const node =
      document.getElementById('tunnel-data') ||
      document.getElementById('TunnelConfig') ||
      document.getElementById('tunnel-config');

    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      console.warn('[tunnel] JSON parse error', err);
      return null;
    }
  }

  function normalizeSteps(root) {
    const s = getField(root, 'steps');
    return Array.isArray(s) ? s : [];
  }

  function normalizeItems(root) {
    const it = getField(root, 'items');
    return Array.isArray(it) ? it : [];
  }

  function stepId(step) {
    const id = pick(step, ['id']) ?? getField(step, 'id');
    return id != null ? String(id) : null;
  }

  function stepName(step) {
    const v = getField(step, 'name');
    return (typeof v === 'string' && v.trim()) ? v.trim() : 'Étape';
  }

  function stepType(step) {
    const v = getField(step, 'type');
    return (typeof v === 'string') ? v.trim() : '';
  }

  function stepPriority(step) {
    const v = getField(step, 'priority');
    const n = Number(v);
    return Number.isFinite(n) ? n : 9999;
  }

  function itemPriority(item) {
    const v = getField(item, 'priority');
    const n = Number(v);
    return Number.isFinite(n) ? n : 9999;
  }

  function itemStepId(item) {
    const flat = getField(item, 'stepId') || pick(item, ['stepId']);
    if (flat) return String(flat);

    const st = getField(item, 'step');
    if (st && (st.id !== undefined && st.id !== null)) return String(st.id);
    if (st && st.value && st.value.id != null) return String(st.value.id);

    return null;
  }

  function itemProducts(item) {
    const p = getField(item, 'products');
    return Array.isArray(p) ? p : [];
  }

  function itemCompatibleIds(item) {
    const flat = getField(item, 'compatibleProductIds') || pick(item, ['compatibleProductIds']);
    if (Array.isArray(flat)) return flat.map(String);

    const cps = getField(item, 'compatible_products');
    if (!Array.isArray(cps)) return [];

    return cps
      .map((cp) => {
        const id = pick(cp, ['id']) ?? getField(cp, 'id');
        return id != null ? String(id) : null;
      })
      .filter(Boolean);
  }

  function productTitle(p) {
    return pick(p, ['title', 'name']) || 'Produit';
  }

  function productImage(p) {
    const img =
      pick(p, ['featured_image', 'featuredImage', 'image']) ||
      (Array.isArray(p.images) ? p.images[0] : null) ||
      (Array.isArray(p.media) ? p.media[0] : null);

    if (!img) return null;
    if (typeof img === 'string') return img;
    return pick(img, ['src', 'url']) || null;
  }

  function productVariantId(p) {
    const direct = pick(p, ['variant_id', 'variantId']);
    if (direct) return String(direct);

    const v =
      pick(p, ['selected_or_first_available_variant', 'selectedOrFirstAvailableVariant']) ||
      (Array.isArray(p.variants) ? p.variants[0] : null);

    if (!v) return null;
    const id = pick(v, ['id']);
    return id != null ? String(id) : null;
  }

  function productPrice(p) {
    const formatted = pick(p, ['price']);
    if (typeof formatted === 'string') return formatted;

    const cents = pick(p, ['price_min', 'priceMin', 'price_cents', 'priceCents']);
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    const value = (n / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${value} €`;
  }

  function productAvailable(p) {
    const v = pick(p, ['available']);
    return v === true || v === 'true' || v === 1 || v === '1';
  }

  function isRecapStep(step) {
    return String(stepType(step)).toLowerCase() === 'recap';
  }

  function renderEmpty(message) {
    if (itemsWrap) itemsWrap.innerHTML = `<p>${escapeHtml(message)}</p>`;
  }

  function updateProgress() {
    const total = steps.length;
    const pct = (total > 1) ? (stepIndex / (total - 1)) * 100 : 100;

    if (progressBar) progressBar.style.width = `${Math.max(0, Math.min(100, pct))}%`;
    if (stepIndicator) stepIndicator.textContent = total ? `Étape ${stepIndex + 1} / ${total}` : '';
  }

  function collectProductImagesFromDom() {
    const selectors = [
      '.product__media img',
      '.product-media img',
      '.product__media-item img',
      '.product-gallery img',
      '.product__media-wrapper img',
      '.swiper-slide img',
      '.splide__slide img'
    ];

    const urls = [];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((img) => {
        const src = img.currentSrc || img.src || img.getAttribute('src');
        if (!src) return;
        const clean = src.split('?')[0];
        if (!urls.includes(clean)) urls.push(clean);
      });
    });

    return urls;
  }

  function renderGallery() {
    if (!visualMain) return;

    if (!gallery.length) {
      visualMain.removeAttribute('src');
      visualMain.setAttribute('alt', '');
      if (visualThumbs) visualThumbs.innerHTML = '';
      if (btnPrevImg) btnPrevImg.disabled = true;
      if (btnNextImg) btnNextImg.disabled = true;
      return;
    }

    galleryIndex = Math.max(0, Math.min(gallery.length - 1, galleryIndex));
    visualMain.src = gallery[galleryIndex];
    visualMain.setAttribute('alt', `Visuel produit ${galleryIndex + 1} sur ${gallery.length}`);

    if (btnPrevImg) btnPrevImg.disabled = (galleryIndex === 0);
    if (btnNextImg) btnNextImg.disabled = (galleryIndex === gallery.length - 1);

    if (visualThumbs) {
      visualThumbs.innerHTML = gallery.map((url, i) => `
        <button
          class="tunnel-visual__dot ${i === galleryIndex ? 'is-active' : ''}"
          type="button"
          data-gal-i="${i}"
          aria-label="Voir image ${i + 1}"
          ${i === galleryIndex ? 'aria-current="true"' : ''}
        ></button>
      `).join('');
    }
  }

  function setVisualFallback() {
    if (!visualMain) return;

    let src =
      tunnelData?.product?.featured_image ||
      tunnelData?.product?.featuredImage ||
      tunnelData?.product?.image ||
      null;

    if (!src) {
      const anyItem = items?.[0];
      const anyProduct = anyItem ? (itemProducts(anyItem)?.[0] || null) : null;
      if (anyProduct) src = productImage(anyProduct);
    }

    if (!src) {
      visualMain.removeAttribute('src');
      visualMain.setAttribute('alt', '');
      if (visualThumbs) visualThumbs.innerHTML = '';
      if (btnPrevImg) btnPrevImg.disabled = true;
      if (btnNextImg) btnNextImg.disabled = true;
      return;
    }

    visualMain.src = src;
    visualMain.setAttribute('alt', '');
    if (visualThumbs) visualThumbs.innerHTML = '';
    if (btnPrevImg) btnPrevImg.disabled = true;
    if (btnNextImg) btnNextImg.disabled = true;
  }

  function clampQty(n) {
    const x = Number(n);
    if (!Number.isFinite(x)) return 1;
    return Math.max(1, Math.min(99, Math.round(x)));
  }

  function normalizeVariantId(raw) {
    if (raw == null) return null;
    const s = String(raw).trim();
    const m = s.match(/(\d{6,})/);
    return m ? m[1] : null;
  }

  function getBaseVariantIdFromDom() {
    const v =
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"][value]') ||
      document.querySelector('input[name="id"]');

    const val = v ? (v.value || v.getAttribute('value') || '') : '';
    return normalizeVariantId(val);
  }

  function getBaseVariantId() {
    const dom = getBaseVariantIdFromDom();
    if (dom) return dom;

    const fromProduct = tunnelData?.product?.variantId || tunnelData?.product?.variant_id;
    if (fromProduct) return normalizeVariantId(fromProduct);
    if (tunnelData?.variantId) return normalizeVariantId(tunnelData.variantId);
    const attr = modal.getAttribute('data-variant-id');
    if (attr) return normalizeVariantId(attr);
    return null;
  }

  function findDomProductTitle() {
    const sel = [
      '[data-product-title]',
      '.product__title .product__heading',
      '.product__heading',
      '.product-title',
      'h1.product__title',
      'h1'
    ];
    for (const s of sel) {
      const el = document.querySelector(s);
      if (!el) continue;
      const clone = el.cloneNode(true);
      clone.querySelectorAll('style, script, [class*="jdgm"]').forEach((n) => n.remove());
      const t = (clone.textContent || '').trim();
      if (t) return t;
    }
    return '';
  }

  function findDomProductPrice() {
    const sel = [
      '[data-product-price]',
      '.price__regular .price-item--regular',
      '.price-item--regular',
      '.price .price-item',
      '.product__price .money',
      '.money'
    ];
    for (const s of sel) {
      const el = document.querySelector(s);
      if (!el) continue;
      const t = (el.textContent || '').trim();
      if (t) return t;
    }
    return '';
  }

  function getVariantRadiosData() {
    const vr = document.querySelector('variant-radios');
    if (!vr) return { options: {}, variants: [] };

    const options = {};
    vr.querySelectorAll('fieldset[data-option-slug]').forEach((fs) => {
      const slug = (fs.getAttribute('data-option-slug') || '').trim().toLowerCase();
      const checked = fs.querySelector('input[type="radio"]:checked');
      const value = checked ? (checked.getAttribute('data-option-value') || checked.value || '') : '';
      if (slug && value) options[slug] = String(value).trim();
    });

    let variants = [];
    const jsonNode = vr.querySelector('script[type="application/json"]');
    if (jsonNode) {
      try {
        const data = JSON.parse(jsonNode.textContent || '[]');
        variants = Array.isArray(data) ? data : [];
      } catch (_) {
        variants = [];
      }
    }

    return { options, variants };
  }

  function resolveBaseVariantLabel() {
    const { options, variants } = getVariantRadiosData();
    const motor = options.motorisation || '';
    const color = options.couleur || '';

    if (motor || color) return [motor, color].filter(Boolean).join(' / ');

    const vid = getBaseVariantIdFromDom();
    if (vid && Array.isArray(variants) && variants.length) {
      const v = variants.find((x) => String(x && x.id) === String(vid));
      if (v) {
        const a = (v.option1 || '').toString().trim();
        const b = (v.option2 || '').toString().trim();
        return [a, b].filter(Boolean).join(' / ');
      }
    }

    return '';
  }

  function getBaseProductInfo() {
    const p = tunnelData?.product || {};
    const title = pick(p, ['title', 'name']) || findDomProductTitle() || 'Produit';
    const price = productPrice(p) || findDomProductPrice() || '';
    const img = (gallery && gallery.length ? gallery[0] : null) || pick(p, ['featured_image', 'featuredImage', 'image']) || null;
    return { title, price, img };
  }

  function renderBaseContext() {
    const base = getBaseProductInfo();
    const { options } = getVariantRadiosData();

    const motor = options.motorisation || '';
    const color = options.couleur || '';

    const metaParts = [];
    if (color) metaParts.push(`Couleur : ${color}`);
    if (motor) metaParts.push(`Motorisation : ${motor}`);

    baseVariantLabel = resolveBaseVariantLabel();

    if (baseTitleEl) baseTitleEl.textContent = base.title || '';
    if (baseMetaEl) baseMetaEl.textContent = metaParts.join(' • ') || baseVariantLabel || '';
  }

  function parsePriceToCents(str) {
    if (!str) return null;

    let s = String(str)
      .replace(/&nbsp;|&#160;|\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    let n = s.replace(/[^\d.,-]/g, '');
    if (!n) return null;

    const hasComma = n.includes(',');
    const hasDot = n.includes('.');

    if (hasComma && hasDot) {
      const lastComma = n.lastIndexOf(',');
      const lastDot = n.lastIndexOf('.');
      if (lastComma > lastDot) n = n.replace(/\./g, '').replace(',', '.');
      else n = n.replace(/,/g, '');
      const val = Number.parseFloat(n);
      return Number.isFinite(val) ? Math.round(val * 100) : null;
    }

    if (hasComma || hasDot) {
      const sep = hasComma ? ',' : '.';
      const idx = n.lastIndexOf(sep);
      const digitsAfter = n.length - idx - 1;
      const countSep = (n.match(new RegExp(`\\${sep}`, 'g')) || []).length;

      if (digitsAfter === 3 && countSep >= 1) {
        const intStr = n.replace(new RegExp(`\\${sep}`, 'g'), '');
        const intVal = Number.parseInt(intStr, 10);
        return Number.isFinite(intVal) ? intVal * 100 : null;
      }

      if (digitsAfter === 0) {
        const intVal = Number.parseInt(n.replace(new RegExp(`\\${sep}`, 'g'), ''), 10);
        return Number.isFinite(intVal) ? intVal * 100 : null;
      }

      const decStr = n.replace(new RegExp(`\\${sep}`, 'g'), '.');
      const val = Number.parseFloat(decStr);
      return Number.isFinite(val) ? Math.round(val * 100) : null;
    }

    const intVal = Number.parseInt(n, 10);
    return Number.isFinite(intVal) ? intVal * 100 : null;
  }

  function formatCentsLike(cents, samplePriceStr) {
    const v = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const sample = (samplePriceStr || '').toString();

    if (sample.includes('€')) return `${v} €`;
    if (sample.includes('$')) return sample.trim().startsWith('$') ? `$${v}` : `${v} $`;
    if (sample.includes('£')) return sample.trim().startsWith('£') ? `£${v}` : `${v} £`;

    const m = sample.match(/\b([A-Z]{3})\b/);
    if (m) return `${v} ${m[1]}`;

    return v;
  }

  function ensureBackButton() {
    if (!footerEl) return;
    if (btnBack) return;

    btnBack = document.createElement('button');
    btnBack.type = 'button';
    btnBack.className = 'tunnel-modal__tertiary';
    btnBack.setAttribute('data-tunnel-back', '');
    btnBack.textContent = 'Retour';
    footerEl.appendChild(btnBack);

    btnBack.addEventListener('click', (e) => {
      e.preventDefault();
      if (isAdding) return;
      if (stepIndex > 0) {
        stepIndex -= 1;
        renderStep();
      }
    });
  }

  function ensureTotal() {
    if (!footerEl) return;
    ensureBackButton();
    if (totalWrap && totalEl) return;

    totalWrap = document.createElement('div');
    totalWrap.className = 'tunnel-modal__recap-bottom';

    totalEl = document.createElement('div');
    totalEl.className = 'tunnel-modal__total';
    totalEl.setAttribute('aria-live', 'polite');

    totalWrap.appendChild(btnBack);
    totalWrap.appendChild(totalEl);
    footerEl.appendChild(totalWrap);
  }

  function updateFooterTotal() {
    if (!totalEl) return;

    const base = getBaseProductInfo();
    const sample =
      base.price ||
      (selectedVariants.size ? (Array.from(selectedVariants.values())[0]?.price || '') : '');

    const baseCents = parsePriceToCents(stripHtml(base.price || '')) ?? 0;
    const baseTotal = baseCents * clampQty(baseQty || 1);

    let accTotal = 0;
    selectedVariants.forEach((x) => {
      const c = parsePriceToCents(stripHtml(x.price || ''));
      if (c != null) accTotal += c * clampQty(x.qty || 1);
    });

    const total = baseTotal + accTotal;
    totalEl.textContent = `Total : ${formatCentsLike(total, sample)}`;
  }

  function setFooterState(recap) {
    if (!footerEl) return;

    footerEl.classList.toggle('is-first-step', stepIndex === 0);
    footerEl.classList.toggle('is-recap-step', recap);

    ensureBackButton();

    if (recap) {
      if (btnPrev) btnPrev.style.display = '';
      if (btnNext) btnNext.style.display = '';
      if (btnBack) btnBack.style.display = '';

      if (btnPrev) btnPrev.textContent = 'Ajouter au panier';
      if (btnNext) btnNext.textContent = 'Acheter';
      if (btnBack) btnBack.textContent = 'Retour';

      ensureTotal();
      if (totalWrap) totalWrap.style.display = '';
      updateFooterTotal();
    } else {
      if (totalWrap) totalWrap.style.display = 'none';
      if (btnBack) btnBack.style.display = 'none';
      if (btnPrev) btnPrev.style.display = (stepIndex === 0) ? 'none' : '';
      if (btnNext) btnNext.textContent = 'Continuer';
      if (btnPrev) btnPrev.textContent = 'Retour';
      if (btnNext) btnNext.disabled = false;
    }
  }

  function renderRecap() {
    if (!itemsWrap) return;

    const base = getBaseProductInfo();
    const list = Array.from(selectedVariants.values());

    const baseLine = `
      <div class="tunnel-group">
        <h4 class="tunnel-group__title">Vélo</h4>
        <div class="tunnel-products">
          <div class="tunnel-product tunnel-product--recap is-checked">
            ${base.img ? `<img class="tunnel-product__img" src="${escapeHtml(base.img)}" alt="${escapeHtml(base.title)}" loading="lazy" decoding="async">` : `<div class="tunnel-product__img"></div>`}

            <div class="tunnel-product__info">
              <p class="tunnel-product__name">${escapeHtml(base.title)}</p>
              <div class="tunnel-product__meta">
                ${baseVariantLabel ? `<span style="font-weight:600;opacity:.8">${escapeHtml(baseVariantLabel)}</span>` : `<span></span>`}
                ${base.price ? `<span>${escapeHtml(stripHtml(base.price))}</span>` : `<span></span>`}
              </div>
            </div>

            <div class="tunnel-recap__qty" data-recap-base>
              <button type="button" class="tunnel-qty__btn" data-qty-dec="base" aria-label="Diminuer la quantité" ${isAdding ? 'disabled' : ''}>−</button>
              <span class="tunnel-qty__val" data-qty-value="base">${baseQty}</span>
              <button type="button" class="tunnel-qty__btn" data-qty-inc="base" aria-label="Augmenter la quantité" ${isAdding ? 'disabled' : ''}>+</button>
            </div>
          </div>
        </div>
      </div>
    `;

    const accessoriesBlock = list.length ? `
      <div class="tunnel-group">
        <h4 class="tunnel-group__title">Accessoires</h4>
        <div class="tunnel-products">
          ${list.map(x => `
            <div class="tunnel-product tunnel-product--recap is-checked">
              ${x.img ? `<img class="tunnel-product__img" src="${escapeHtml(x.img)}" alt="${escapeHtml(x.title)}" loading="lazy" decoding="async">` : `<div class="tunnel-product__img"></div>`}

              <div class="tunnel-product__info">
                <p class="tunnel-product__name">${escapeHtml(x.title)}</p>
                <div class="tunnel-product__meta">
                  ${x.price ? `<span>${escapeHtml(stripHtml(x.price))}</span>` : `<span></span>`}
                </div>
              </div>

              <div class="tunnel-recap__qty" data-recap-variant="${escapeHtml(x.variantId)}">
                <button type="button" class="tunnel-qty__btn" data-qty-dec="${escapeHtml(x.variantId)}" aria-label="Diminuer la quantité" ${isAdding ? 'disabled' : ''}>−</button>
                <span class="tunnel-qty__val" data-qty-value="${escapeHtml(x.variantId)}">${escapeHtml(String(x.qty || 1))}</span>
                <button type="button" class="tunnel-qty__btn" data-qty-inc="${escapeHtml(x.variantId)}" aria-label="Augmenter la quantité" ${isAdding ? 'disabled' : ''}>+</button>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    ` : `
      <div class="tunnel-group">
        <h4 class="tunnel-group__title">Accessoires</h4>
        <p>Aucun accessoire sélectionné.</p>
      </div>
    `;

    itemsWrap.innerHTML = `
      ${baseLine}
      ${accessoriesBlock}
    `;

    updateFooterTotal();
  }

  function decodeVariantsPayload(str) {
    try {
      const json = decodeURIComponent(str);
      const data = JSON.parse(json);
      return Array.isArray(data) ? data : [];
    } catch (_) {
      return [];
    }
  }

  function formatMoneyFromCents(cents, sample) {
    const v = (Number(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (sample && String(sample).includes('€')) return `${v} €`;
    return v;
  }

  function upgradeVariantSelectors() {
    const cards = Array.from(modal.querySelectorAll('.tunnel-product'));
    for (const card of cards) {
      const checkbox = card.querySelector('[data-tunnel-variant]');
      if (!checkbox) continue;
      if (card.querySelector('[data-tunnel-variant-select]')) continue;

      const payload = checkbox.getAttribute('data-variants') || '';
      if (!payload) continue;

      const variants = decodeVariantsPayload(payload);
      if (!Array.isArray(variants) || variants.length <= 1) continue;

      const select = document.createElement('select');
      select.className = 'tunnel-product__variant';
      select.setAttribute('data-tunnel-variant-select', '');
      select.setAttribute('aria-label', 'Choisir une option');

      const currentVid = normalizeVariantId(checkbox.getAttribute('data-variant-id'));

      variants.forEach((v) => {
        const id = normalizeVariantId(v && v.id);
        if (!id) return;
        const opt = document.createElement('option');
        opt.value = id;
        opt.textContent = (v.title || '').trim() || 'Option';
        if (v.available === false) opt.disabled = true;
        if (currentVid && id === currentVid) opt.selected = true;
        if (v.price != null && String(v.price).trim() !== '') opt.setAttribute('data-price', String(v.price));
        select.appendChild(opt);
      });

      const info = card.querySelector('.tunnel-product__info');
      if (info) {
        const wrap = document.createElement('div');
        wrap.className = 'tunnel-product__variant-wrap';
        wrap.appendChild(select);
        info.appendChild(wrap);
      }

      select.addEventListener('change', () => {
        const vid = normalizeVariantId(select.value);
        if (!vid) return;

        checkbox.setAttribute('data-variant-id', vid);

        const priceNode = card.querySelector('.tunnel-product__meta > span:first-child');
        const opt = select.selectedOptions && select.selectedOptions[0] ? select.selectedOptions[0] : null;
        const optPrice = opt ? opt.getAttribute('data-price') : null;

        if (optPrice && priceNode) {
          const sample = checkbox.getAttribute('data-price') || '';
          priceNode.textContent = formatMoneyFromCents(optPrice, sample);
          checkbox.setAttribute('data-price', priceNode.textContent);
        }

        if (!checkbox.checked) return;

        const titleBase = checkbox.getAttribute('data-title') || 'Produit';
        const img = checkbox.getAttribute('data-img') || '';
        const price = checkbox.getAttribute('data-price') || '';
        const optLabel = opt ? (opt.textContent || '').trim() : '';

        selectedVariants.forEach((v, key) => {
          if (v && v.title && v.title.startsWith(titleBase)) selectedVariants.delete(key);
        });

        selectedVariants.set(vid, {
          variantId: vid,
          qty: 1,
          title: optLabel ? `${titleBase} — ${optLabel}` : titleBase,
          img,
          price
        });

        const step = steps[stepIndex];
        if (step && isRecapStep(step)) renderRecap();
      });
    }
  }

  function normalizeUrlToHandle(url) {
    if (!url) return '';
    const s = String(url).trim();
    const m = s.match(/\/products\/([^/?#]+)/i);
    return m ? m[1] : '';
  }

  async function fetchVariantsByHandle(handle) {
    const h = String(handle || '').trim();
    if (!h) return [];

    if (variantsCache.has(h)) return variantsCache.get(h);

    try {
      const res = await fetch(`/products/${encodeURIComponent(h)}.js`, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('fetch failed');
      const data = await res.json();
      const list = Array.isArray(data && data.variants) ? data.variants : [];
      variantsCache.set(h, list);
      return list;
    } catch (_) {
      variantsCache.set(h, []);
      return [];
    }
  }

  function buildVariantsPayload(variants) {
    const clean = (Array.isArray(variants) ? variants : [])
      .map(v => ({
        id: normalizeVariantId(v && v.id),
        title: (v && (v.public_title || v.title)) ? String(v.public_title || v.title) : '',
        available: v && v.available !== false,
        price: (v && v.price != null) ? String(v.price) : ''
      }))
      .filter(v => v.id);

    if (clean.length <= 1) return '';
    return encodeURIComponent(JSON.stringify(clean));
  }

  async function hydrateMissingVariants() {
    const tick = ++hydrateTick;
    const inputs = Array.from(modal.querySelectorAll('input[data-tunnel-variant]'));

    const tasks = inputs.map(async (input) => {
      if (tick !== hydrateTick) return;
      if (input.getAttribute('data-variants')) return;

      const title = (input.getAttribute('data-title') || '').trim();
      if (!title) return;

      const key = title.toLowerCase();
      const handle = TITLE_TO_HANDLE[key] || '';
      if (!handle) return;

      const list = await fetchVariantsByHandle(handle);
      if (tick !== hydrateTick) return;

      const payload = buildVariantsPayload(list);
      if (!payload) return;

      input.setAttribute('data-variants', payload);

      const currentVid = normalizeVariantId(input.getAttribute('data-variant-id'));
      if (!currentVid && list.length) {
        const first = list.find(v => v && v.available !== false) || list[0];
        const fid = normalizeVariantId(first && first.id);
        if (fid) input.setAttribute('data-variant-id', fid);
      }
    });

    await Promise.all(tasks);
    if (tick !== hydrateTick) return;

    upgradeVariantSelectors();
  }

  function renderStep() {
    if (!steps.length) {
      if (titleEl) titleEl.textContent = 'Configuration';
      renderEmpty('Aucune étape configurée.');
      if (btnPrev) btnPrev.style.display = 'none';
      if (btnNext) btnNext.textContent = 'Fermer';
      updateProgress();
      return;
    }

    const step = steps[stepIndex];
    const recap = isRecapStep(step);

    let stepNameText = stepName(step);

    if (recap) {
      stepNameText = 'Récap';
    } else {
      const nonRecapSteps = steps.filter((s) => !isRecapStep(s));
      const idx = nonRecapSteps.findIndex((s) => String(stepId(s)) === String(stepId(step)));
      const labels = nonRecapSteps.length === 2 ? CATEGORY_LABELS_2
             : nonRecapSteps.length === 3 ? CATEGORY_LABELS_3
             : CATEGORY_LABELS_4;
if (idx >= 0 && idx < labels.length) stepNameText = labels[idx];
    }

    if (titleEl) titleEl.textContent = stepNameText;

    setFooterState(recap);
    updateProgress();

    if (recap) {
      renderRecap();
      return;
    }

    const currentStepId = stepId(step);

    const stepItems = items
      .filter((it) => String(itemStepId(it)) === String(currentStepId))
      .sort((a, b) => itemPriority(a) - itemPriority(b));

    if (!stepItems.length) {
      renderEmpty('Aucun accessoire dans cette étape.');
      return;
    }

    if (!itemsWrap) return;

    itemsWrap.innerHTML = stepItems.map((it) => {
      const products = itemProducts(it);

      if (!products.length) {
        return `
          <div class="tunnel-group">
            <p>Aucun produit configuré.</p>
          </div>
        `;
      }

      const cards = products.map((p) => {
        const pTitle = productTitle(p);
        const img = productImage(p);
        const price = productPrice(p);
        const variantId = normalizeVariantId(productVariantId(p));
        const available = productAvailable(p);

        const variants = Array.isArray(p.variants) ? p.variants : [];
        const variantsPayload = buildVariantsPayload(variants);

        if (!available && variantId) selectedVariants.delete(variantId);

        const checked = variantId && selectedVariants.has(variantId) ? 'checked' : '';
        const disabledAttr = (!variantId || !available) ? 'disabled' : '';
        const stockBadge = available ? '' : `<span class="tunnel-product__stock">Rupture de stock</span>`;

        return `
          <label class="tunnel-product ${!available ? 'is-oos' : ''} ${(variantId && selectedVariants.has(variantId)) ? 'is-checked' : ''}">
            ${img
              ? `<img class="tunnel-product__img" src="${escapeHtml(img)}" alt="${escapeHtml(pTitle)}" loading="lazy" decoding="async">`
              : `<div class="tunnel-product__img"></div>`
            }

            <div class="tunnel-product__info">
              <p class="tunnel-product__name">${escapeHtml(pTitle)}</p>
              <div class="tunnel-product__meta">
                ${price ? `<span>${escapeHtml(stripHtml(price))}</span>` : `<span></span>`}
                ${stockBadge}
              </div>
            </div>

            <input
              class="tunnel-product__check"
              type="checkbox"
              data-tunnel-variant
              ${variantId ? `data-variant-id="${escapeHtml(variantId)}"` : ``}
              ${variantsPayload ? `data-variants="${escapeHtml(variantsPayload)}"` : ``}
              data-title="${escapeHtml(pTitle)}"
              ${img ? `data-img="${escapeHtml(img)}"` : ``}
              ${price ? `data-price="${escapeHtml(stripHtml(price))}"` : ``}
              ${checked}
              ${disabledAttr}
            />
          </label>
        `;
      }).join('');

      return `
        <div class="tunnel-group">
          <div class="tunnel-products">${cards}</div>
        </div>
      `;
    }).join('');

    upgradeVariantSelectors();
    hydrateMissingVariants();
  }

  async function addToCart(redirectTo = '/cart', triggerBtn = null) {
    if (isAdding) return;

    const baseVariantId = normalizeVariantId(getBaseVariantId());
    if (!baseVariantId) {
      renderEmpty('Variant principal introuvable. Vérifie input[name="id"] / product.variantId / data-variant-id.');
      return;
    }

    const snapshotBaseQty = clampQty(baseQty || 1);
    const snapshotAccessories = Array.from(selectedVariants.values())
      .map((v) => ({
        id: Number(normalizeVariantId(v.variantId)),
        quantity: clampQty(v.qty || 1),
      }))
      .filter((x) => Number.isFinite(x.id) && x.id > 0 && x.quantity > 0);

    const itemsToAdd = [
      { id: Number(baseVariantId), quantity: snapshotBaseQty },
      ...snapshotAccessories,
    ].filter((x) => Number.isFinite(x.id) && x.id > 0 && x.quantity > 0);

    if (!itemsToAdd.length) {
      renderEmpty('Aucun article à ajouter.');
      return;
    }

    isAdding = true;
    modal.classList.add('tunnel-is-adding');

    if (triggerBtn) triggerBtn.disabled = true;
    if (btnBack) btnBack.setAttribute('aria-disabled', 'true');

    let timeoutId = null;
    let didTimeout = false;

    const hardTimeout = new Promise((_, reject) => {
      timeoutId = setTimeout(() => {
        didTimeout = true;
        reject(new Error('timeout'));
      }, 30000);
    });

    const tryJsonAdd = async () => {
      let res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: itemsToAdd }),
      });

      if (res.status === 429) {
        await retryAfterDelay(res);
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsToAdd }),
        });
      }

      return res;
    };

    const tryFormAdd = async () => {
      const body = new URLSearchParams();
      itemsToAdd.forEach((line, i) => {
        body.set(`items[${i}][id]`, String(line.id));
        body.set(`items[${i}][quantity]`, String(line.quantity));
      });

      let res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body,
      });

      if (res.status === 429) {
        await retryAfterDelay(res);
        res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body,
        });
      }

      return res;
    };

    try {
      const res1 = await Promise.race([tryJsonAdd(), hardTimeout]);

      if (!res1.ok) {
        const res2 = await Promise.race([tryFormAdd(), hardTimeout]);

        if (!res2.ok) {
          const ct = res2.headers.get('content-type') || '';
          const dataOrText = ct.includes('application/json') ? await res2.json() : await res2.text();
          const msg =
            (dataOrText && typeof dataOrText === 'object' && dataOrText.message)
              ? dataOrText.message
              : 'Erreur lors de l’ajout au panier.';

          if (itemsWrap) {
            itemsWrap.insertAdjacentHTML('afterbegin', `<p style="color:#b00020;font-weight:600;">${escapeHtml(msg)}</p>`);
          }
          return;
        }
      }

      await new Promise((r) => setTimeout(r, 150));
      window.location.assign(redirectTo);
    } catch (err) {
      const msg = didTimeout ? 'L’ajout prend trop de temps. Réessaie.' : 'Erreur lors de l’ajout au panier. Réessaie.';
      if (itemsWrap) {
        itemsWrap.insertAdjacentHTML('afterbegin', `<p style="color:#b00020;font-weight:600;">${escapeHtml(msg)}</p>`);
      }
    } finally {
      if (timeoutId) clearTimeout(timeoutId);

      isAdding = false;
      modal.classList.remove('tunnel-is-adding');

      if (btnBack) btnBack.removeAttribute('aria-disabled');
      if (triggerBtn) triggerBtn.disabled = false;

      const step = steps[stepIndex];
      const recap = step && isRecapStep(step);

      if (btnNext) btnNext.textContent = recap ? 'Acheter' : 'Continuer';
      if (btnPrev) btnPrev.disabled = false;
      if (btnNext) btnNext.disabled = false;

      if (recap) renderRecap();
    }
  }

  function openModal() {
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';

    (panel || modal).addEventListener('keydown', trapFocus);

    tunnelData = readTunnelData();
    const root = tunnelData?.config ? tunnelData.config : tunnelData;

    steps = [];
    items = [];
    stepIndex = 0;
    selectedVariants.clear();
    baseQty = 1;

    baseVariantIdSnapshot = normalizeVariantId(getBaseVariantId());

    if (root) {
      steps = normalizeSteps(root).slice().sort((a, b) => stepPriority(a) - stepPriority(b));
      items = normalizeItems(root).slice();
    }

    const currentProductId = tunnelData?.product?.id ? String(tunnelData.product.id) : null;
    if (currentProductId) {
      items = items.filter((it) => {
        const ids = itemCompatibleIds(it);
        return !ids.length || ids.includes(currentProductId);
      });
    }

    items.sort((a, b) => itemPriority(a) - itemPriority(b));

    gallery = collectProductImagesFromDom();
    galleryIndex = 0;

    if (gallery.length) renderGallery();
    else setVisualFallback();

    renderBaseContext();
    renderStep();

    fetchVariantsByHandle('mise-en-service-du-fat-street-x-trail').then(() => {
  if (modal.hidden) return;
  hydrateMissingVariants();
});

    requestAnimationFrame(() => {
      const closeBtn = modal.querySelector('.tunnel-modal__close,[data-tunnel-close]');
      if (closeBtn) closeBtn.focus();
      else if (btnNext) btnNext.focus();
      else (panel || modal).focus();
    });
  }

  function closeModal() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    (panel || modal).removeEventListener('keydown', trapFocus);

    if (lastOpener) lastOpener.focus();
    lastOpener = null;
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-tunnel]');
    if (opener) {
      lastOpener = opener;
      openModal();
      return;
    }
    if (e.target.closest('[data-tunnel-close]')) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  modal.addEventListener('change', (e) => {
    const input = e.target.closest('[data-tunnel-variant]');
    if (!input) return;

    const card = input.closest('.tunnel-product');
    if (card) card.classList.toggle('is-checked', input.checked);

    if (input.disabled) {
      input.checked = false;
      if (card) card.classList.remove('is-checked');
      return;
    }

    const variantId = normalizeVariantId(input.getAttribute('data-variant-id'));
    if (!variantId) return;

    const title = input.getAttribute('data-title') || 'Produit';
    const img = input.getAttribute('data-img') || '';
    const price = input.getAttribute('data-price') || '';

    let finalTitle = title;
    const sel = card ? card.querySelector('[data-tunnel-variant-select]') : null;
    if (sel && sel.selectedOptions && sel.selectedOptions[0]) {
      const optTitle = (sel.selectedOptions[0].textContent || '').trim();
      if (optTitle) finalTitle = `${title} — ${optTitle}`;
    }

    if (input.checked) {
      const prev = selectedVariants.get(variantId);
      selectedVariants.set(variantId, {
        variantId,
        qty: clampQty(prev?.qty || 1),
        title: finalTitle,
        img,
        price
      });
    } else {
      selectedVariants.delete(variantId);
    }

    const step = steps[stepIndex];
    if (step && isRecapStep(step)) updateFooterTotal();
  });

  modal.addEventListener('click', (e) => {
    if (isAdding) return;

    const dec = e.target.closest('[data-qty-dec]');
    const inc = e.target.closest('[data-qty-inc]');
    if (!dec && !inc) return;

    const step = steps[stepIndex];
    const recap = step && isRecapStep(step);
    if (!recap) return;

    const id = (dec ? dec.getAttribute('data-qty-dec') : inc.getAttribute('data-qty-inc')) || '';
    const delta = dec ? -1 : 1;

    if (id === 'base') {
      baseQty = clampQty((baseQty || 1) + delta);
      renderRecap();
      return;
    }

    const vid = normalizeVariantId(id);
    if (!vid || !selectedVariants.has(vid)) return;

    const entry = selectedVariants.get(vid);
    entry.qty = clampQty((entry.qty || 1) + delta);
    selectedVariants.set(vid, entry);
    renderRecap();
  });

  if (btnPrevImg) {
    btnPrevImg.addEventListener('click', () => {
      galleryIndex -= 1;
      renderGallery();
    });
  }

  if (btnNextImg) {
    btnNextImg.addEventListener('click', () => {
      galleryIndex += 1;
      renderGallery();
    });
  }

  if (visualThumbs) {
    visualThumbs.addEventListener('click', (e) => {
      const b = e.target.closest('[data-gal-i]');
      if (!b) return;
      galleryIndex = Number(b.getAttribute('data-gal-i')) || 0;
      renderGallery();
    });
  }

  if (btnPrev) {
    btnPrev.addEventListener('click', (e) => {
      e.preventDefault();
      if (isAdding) return;

      const step = steps[stepIndex];
      const recap = step && isRecapStep(step);

      if (recap) {
        addToCart('/cart', e.currentTarget);
        return;
      }

      if (stepIndex > 0) {
        stepIndex -= 1;
        renderStep();
      }
    });
  }

  if (btnNext) {
    btnNext.addEventListener('click', (e) => {
      e.preventDefault();
      if (isAdding) return;

      const step = steps[stepIndex];
      const recap = step && isRecapStep(step);

      if (recap) {
        addToCart('/checkout', e.currentTarget);
        return;
      }

      if (stepIndex < steps.length - 1) {
        stepIndex += 1;
        renderStep();
      } else {
        closeModal();
      }
    });
  }
})();
